"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMainBonusData = void 0;
var profile_api_1 = require("@l2p/profile-api");
var public_api_1 = require("@l2p/public-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var useMainBonusData = function (data) {
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var formatCurrency = (0, swr_hooks_1.useCurrencyFormat)();
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'number',
                    label: '',
                },
                {
                    field: 'bonus',
                    label: t('bonus'),
                },
                {
                    field: 'fs',
                    label: t('fs'),
                },
                {
                    field: 'minDeposit',
                    label: t('minDeposit'),
                },
            ],
            rows: [],
        };
        table.rows = data
            .map(function (item, idx) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var minDeptBonusSettings = (_b = (_a = item === null || item === void 0 ? void 0 : item.conditions) === null || _a === void 0 ? void 0 : _a.find(function (r) { return r.type === profile_api_1.BonusConditionType.MinDepositAmount; })) === null || _b === void 0 ? void 0 : _b.minDeposit;
            var minDep = (_c = minDeptBonusSettings === null || minDeptBonusSettings === void 0 ? void 0 : minDeptBonusSettings.find(function (b) { return b.currency === currentCurrency; })) === null || _c === void 0 ? void 0 : _c.amount;
            var freespins = ((_e = (_d = item === null || item === void 0 ? void 0 : item.rewards) === null || _d === void 0 ? void 0 : _d.find(function (r) {
                return r.type === public_api_1.BonusRewardType.FreeRounds ||
                    r.type === public_api_1.BonusRewardType.RepeatableFreeRounds;
            })) === null || _e === void 0 ? void 0 : _e.freeRoundsCount) || 0;
            var percents = ((_g = (_f = item === null || item === void 0 ? void 0 : item.rewards) === null || _f === void 0 ? void 0 : _f.find(function (r) { return r.type === public_api_1.BonusRewardType.Relative; })) === null || _g === void 0 ? void 0 : _g.relativePercent) || 0;
            var maxBonusData = (_h = item === null || item === void 0 ? void 0 : item.constraints) === null || _h === void 0 ? void 0 : _h.find(function (r) { return (r === null || r === void 0 ? void 0 : r.type) === public_api_1.BonusConstraintType.MaxBonus; });
            var maxBonus = (_k = (_j = maxBonusData === null || maxBonusData === void 0 ? void 0 : maxBonusData.maxBonus) === null || _j === void 0 ? void 0 : _j.find(function (b) { return b.currency === currentCurrency; })) === null || _k === void 0 ? void 0 : _k.amount;
            return {
                number: idx + 1,
                bonus: percents
                    ? "".concat(percents, "% ").concat(t('upTo'), " ").concat(formatCurrency(maxBonus))
                    : '',
                fs: freespins ? (react_1.default.createElement("span", { style: { textTransform: 'uppercase' } },
                    freespins,
                    " ",
                    t('fs'))) : ('-'),
                minDeposit: formatCurrency(minDep),
            };
        })
            .filter(function (b) { return Boolean(b.bonus); });
        return table;
    }, [data, t, formatCurrency, currentCurrency]);
};
exports.useMainBonusData = useMainBonusData;
